// extracted by css-extract-rspack-plugin
export default {"legacy":"legacy-y5hJW2","sm":"sm-u4LqJa"};